var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"flex flex-col"},[(_vm.label)?_c('span',{staticClass:"text-sm font-medium text-gray-80"},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }